import { ServiceTokens } from "$src/domain/ServiceTokens";
import type { IDocumentRepository } from "$src/domain/projects/documents/IDocumentRepository";
import { BlobResult } from "$src/infrastructure/network/BlobResult";
import { inject, injectable } from "tsyringe";

@injectable()
export class GetDocumentFileById {
    
    constructor(@inject(ServiceTokens.DocumentRepository) private documentRepository: IDocumentRepository) {}

    async execute(groupStoreId: number, projectId: number, documentId: string): Promise<BlobResult> {
        var blobUrl = await this.documentRepository.getDocumentFileBlobUrl(groupStoreId, projectId, documentId);
        return blobUrl;
    }
}

export const GetDocumentFileByIdToken = Symbol('GetDocumentFileByIdToken'); 